import React, { useRef } from 'react';
import useForm from 'components/use-form';
import AbilityInfoEdit from 'pages/regist/formComponent/Ability';
import { AgencyAbility } from 'model/agency';
import { AgencyDetailProps } from '../../use-agency-detail';
import { abilityFormConfig } from '../config';

const AbilityInfo: React.FC<AgencyDetailProps> = (props) => {
  const formRef = useRef<any>();
  const data = (props.data?.agency_ability || {}) as AgencyAbility;

  const { Form } = useForm({
    data,
    mode: 'text',
    title: '能力信息',
    config: abilityFormConfig,
    EditComponent: AbilityInfoEdit,
    editProps: {
      initData: {
        ...data,
        service_industry: data.service_industry?.map(({ industry_id }) => industry_id) || [],
      },
      ref: formRef,
    },
    onSubmit: async (editClose) => {
      const formData = formRef?.current?.submit?.();
      if (!formData) return;
      const data = {
        ...formData,
        service_industry: formData.service_industry?.map((industry_id: number) => ({ industry_id })) || [],
      };
      const isSuccess = await props.onUpdate({ agency_ability: data });
      if (isSuccess) {
        editClose();
      }
    },
  });

  return Form;
};

export default AbilityInfo;
